import { Form, Input, InputNumber, Switch } from '@arco-design/web-react'
import SettingSectionCard from '../SettingSectionCard'
import type { OptionsAPI } from '../useOptions'

const KEYS = [
  'TopUpLink',
  'DemoSiteEnabled',
  'SelfUseModeEnabled',
  'DrawingEnabled',
  'TaskEnabled',
  'DataExportEnabled',
  'DataExportDefaultTime',
  'DataExportInterval',
]

export default function OperationSwitchesSection({ options }: { options: OptionsAPI }) {
  const { get, getBool, getNumber, patch } = options

  return (
    <SettingSectionCard title="运营开关" subtitle="充值链接、演示站点与自用模式" keys={KEYS} options={options}>
      <Form layout="vertical">
        <div className="grid md:grid-cols-2 gap-3">
          <Form.Item label="充值链接">
            <Input value={get('TopUpLink')} onChange={(v) => patch({ TopUpLink: v })} placeholder="发卡网站购买链接" />
          </Form.Item>
          <Form.Item label="演示站点模式">
            <Switch checked={getBool('DemoSiteEnabled')} onChange={(v) => patch({ DemoSiteEnabled: v })} />
          </Form.Item>
          <Form.Item label="自用模式" extra="开启后不限制必须设置模型倍率">
            <Switch checked={getBool('SelfUseModeEnabled')} onChange={(v) => patch({ SelfUseModeEnabled: v })} />
          </Form.Item>
          <Form.Item label="启用绘图（Midjourney 等）">
            <Switch checked={getBool('DrawingEnabled')} onChange={(v) => patch({ DrawingEnabled: v })} />
          </Form.Item>
          <Form.Item label="启用异步任务（视频/音乐等）">
            <Switch checked={getBool('TaskEnabled')} onChange={(v) => patch({ TaskEnabled: v })} />
          </Form.Item>
          <Form.Item label="数据导出" extra="关闭后用户无法导出用量数据">
            <Switch checked={getBool('DataExportEnabled')} onChange={(v) => patch({ DataExportEnabled: v })} />
          </Form.Item>
          <Form.Item label="导出默认时间范围" extra="例如 hour / day / week">
            <Input
              value={get('DataExportDefaultTime')}
              onChange={(v) => patch({ DataExportDefaultTime: v })}
              placeholder="day"
            />
          </Form.Item>
          <Form.Item label="导出间隔（分钟）" extra="导出任务批量落库的时间粒度">
            <InputNumber
              style={{ width: '100%' }}
              min={1}
              value={getNumber('DataExportInterval', 60)}
              onChange={(v) => patch({ DataExportInterval: v ?? 60 })}
            />
          </Form.Item>
        </div>
      </Form>
    </SettingSectionCard>
  )
}
